/**
 * monitor 模块中仅 EE 存在的菜单项
 */
import store from '@/store'
import Layout from '@/layouts/RouterView'
import i18n from '@/locales'
import { hasServices, featureMenuHiddenCheck } from '@/utils/auth'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const BastionHost = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/bastion-host')

export const bastionHostMenu = {
  meta: {
    label: i18n.t('bastionHost.title'),
  },
  subGroup: 'helm',
  submenus: [
    {
      path: '/bastion-host',
      meta: {
        label: i18n.t('bastionHost.title'),
        permission: 'bastion_hosts_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.bastion_host')) {
            return true
          }
          if (!hasServices('bastionhost') || !store.getters.isAdminMode || store.getters.isSysCE) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'BastionHost',
          path: '',
          component: BastionHost,
        },
      ],
    },
  ],
}
